import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { AccountDelete, AccountDeleteProps } from './AccountDeleted'

export const AccountDeletedRegistration = createRegisterableComponent(
    'account-deleted',
    (props: AccountDeleteProps) => {
        return <AccountDelete {...props} />
    },
)
